export class AbortMap {
  #abortControllers = new Map<string, AbortController>();

  newSignal(id: string): AbortSignal {
    let controller = this.#abortControllers.get(id);
    if (!controller) {
      controller = new AbortController();
      this.#abortControllers.set(id, controller);
    }
    return controller.signal;
  }

  has(id: string): boolean {
    return this.#abortControllers.has(id);
  }

  abort(id: string) {
    this.#abortControllers.get(id)?.abort();
    this.#abortControllers.delete(id);
  }

  delete(id: string) {
    this.#abortControllers.delete(id);
  }
}
